// @flow

import React, {Component} from 'react';
import {connect} from 'react-redux';
import {ADMIN, CUSTOMER, SITE_MANAGER, DEMO} from '../../roles';
import {getSelf} from '../../actions/auth';
import AdminContainer from '../AdminContainer/AdminContainer';
import CustomerContainer from '../CustomerContainer/CustomerContainer';
import SiteManagerContainer from '../SiteManagerContainer/SiteManagerContainer';
import LoadingIndicator from '../../components/LoadingIndicator/LoadingIndicator';
import './App.css';

export type Props = {
  currentUser: ?any,
  getSelf: Function,
};

class App extends Component<Props> {
  props: Props;

  componentWillMount() {
    if (!this.props.currentUser) {
      this.props.getSelf();
    }
  }

  render() {
    const {
      currentUser,
    } = this.props;

    return (
      <div className="App">
        {currentUser && currentUser.role === ADMIN &&
          <AdminContainer pathname="/admin" />
        }
        {currentUser && (currentUser.role === CUSTOMER || currentUser.role === DEMO) &&
          <CustomerContainer user={currentUser} />
        }
        {currentUser && currentUser.role === SITE_MANAGER &&
          <SiteManagerContainer />
        }
        {!currentUser &&
          <LoadingIndicator isLoading={true}/>
        }
      </div>
    );
  }
}

const mapStateToProps = ({
  auth: {
    currentUser,
  },
}) => ({
  currentUser,
});

const mapDispatchToProps = dispatch => ({
  getSelf: () =>
    dispatch(getSelf()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(App);



// WEBPACK FOOTER //
// ./src/containers/App/App.js